import Vue from "vue";
import VueRouter from "vue-router";
import Module1 from "../views/module1/Module1.vue";
import Module2 from "../views/module2/Module2.vue";
import Module3 from "../views/module3/Module3.vue";
import Module4 from "../views/module4/Module4.vue";
import Module5 from "../views/module5/Module5.vue";

Vue.use(VueRouter);

// let locale = window.location.pathname.replace(/^\/([^/]+).*/i, "$1");

const routes = [
  {
    path: "/",
    name: "Root",
    component: () => {
      window.location.href = "//fastheroes.com/e-books/";
    }
  },
  {
    path: "/book-1",
    name: "Module1",
    component: Module1
  },
  {
    path: "/book-2",
    name: "Module2",
    component: Module2
  },
  {
    path: "/book-3",
    name: "Module3",
    component: Module3
  },
  {
    path: "/book-4",
    name: "Module4",
    component: Module4
  },
  {
    path: "/book-5",
    name: "Module5",
    component: Module5
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // base: locale.trim().length && locale != "/" ? "/" + locale : undefined,
  routes
});

export default router;
